import {useFormContext, Controller} from "react-hook-form";
import {ChangeEvent} from "react";
import ProcessTextField from "views/ProcessDetails/refactor/components/ProcessTextField";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  index: number;
  disabled: boolean;
};

const VoyageObservations = (props: Props) => {
  const {index, disabled} = props;
  const {control} = useFormContext<Process>();
  return (
    <Controller
      name={
        `boarding.voyages.${index}.observation` as `boarding.voyages.0.observation`
      }
      control={control}
      render={({field: {onChange, value}}) => (
        <ProcessTextField
          name={`boarding.voyages.${index}.observation`}
          placeholder="Observações"
          value={value ?? ""}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            onChange(e.target.value === "" ? null : e.target.value);
          }}
          size="small"
          fullWidth
          label="Observações"
          disabled={disabled}
        />
      )}
    />
  );
};

export default VoyageObservations;
